import { Component, ViewChild, ElementRef, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import {
  ScannerQRCodeResult,
  NgxScannerQrcodeComponent,
  ScannerQRCodeSelectedFiles,
} from 'ngx-scanner-qrcode';
import { StatutCommande } from '../../../_models/StatutCommande';
import { StatutCommandeService } from '../../../_services/StatutCommandeService';
import { Location } from '@angular/common';
import { GlobalService } from '../../../_services/GlobalService';
import { SacService } from '../../../_services/SacService';
import { TypeSacCremation } from '../../../_models/TypeSacCremation';
import { DataModelUpdateStatutCommande } from '../../../_models/DataModelController/DataModelUpdateStatutCommande';
import { trashIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-qr-code-multi',
  templateUrl: './qr-code-multi.component.html',
  styleUrls: ['./qr-code-multi.component.scss']
})
export class QrCodeMultiComponent implements OnInit, OnDestroy, AfterViewInit {

  public resultEtiquetteTypeSac: DataModelUpdateStatutCommande[] = [];
  public qrCodeResult: ScannerQRCodeSelectedFiles[] = [];
  public qrCodeResult2: ScannerQRCodeSelectedFiles[] = [];
  public StatutCommandes: StatutCommande[] = [];
  public TypesSacCremation: TypeSacCremation[] = [];
  public StatutCommandeSelect: StatutCommande = new StatutCommande();
  TxtLstEtiquettes: string = "";
  messageErreurInformation: string = "";
  messageSuccesInformation: string = "";
  TxtAjoutEtiquetteManuelle: number = 0;
  icon: any = trashIcon;
  loading: boolean = false;

  @ViewChild('ajoutEtiquetteTextBox', { read: ElementRef }) ajoutEtiquetteTextBox!: ElementRef;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef;
  @ViewChild('audioPlayerErreur') audioPlayerErreur!: ElementRef;
  @ViewChild('action') action!: NgxScannerQrcodeComponent;

  constructor(
    public _GlobalService: GlobalService,
    private _location: Location,
    private _StatutCommandeService: StatutCommandeService,
    private _SacService: SacService
  ) { }

  async ngOnInit() {

    history.pushState(null, '', location.href);

    this.loading = true;
    this.StatutCommandes = (await this._StatutCommandeService.GetAllStatuts()).objet;

    this.StatutCommandeSelect = this.isChauffeur() ? this.StatutCommandes[1] : this.StatutCommandes[2];

    this.TypesSacCremation = (await this._SacService.GetAllTaillesSac()).objet;

    if (!this.isChauffeur()) {
      this.StatutCommandes = this.StatutCommandes.slice(2);
      this.StatutCommandes = this.StatutCommandes.filter(s => s.nom !== "En crémation");
    }

    this.loading = false;
  }

  isChauffeur() {
    return localStorage.getItem('Role')?.toLowerCase() === 'chauffeur';
  }

  ngAfterViewInit(): void {
    const inputElement = this.ajoutEtiquetteTextBox.nativeElement.querySelector('input');
    if (inputElement) {
      inputElement.setAttribute('inputmode', 'numeric');
      inputElement.setAttribute('pattern', '[0-9]*');
    }
    this.DemarerScan();
  }

  ngOnDestroy(): void {
    this.StopScan();
    this.releaseCamera();
  }

  public DemarerScan(): void {
    this.handle(this.action, 'start');
  }

  public StopScan(): void {
    this.handle(this.action, 'stop');
  }

  private releaseCamera(): void {
    const video: HTMLVideoElement | null = document.querySelector('video');
    if (video && video.srcObject instanceof MediaStream) {
      video.srcObject.getTracks().forEach(track => track.stop());
      video.srcObject = null;
    }
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    if (e && e.length > 0) {
      this.AjouterEtiquette(parseInt(e[0].value, 10));
    }
  }

  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      const device = devices.find(f => /(back)/gi.test(f.label));
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    };

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe({
        error: (error: any) => {
          if (error instanceof DOMException && error.name === 'NotAllowedError') {
            alert("Veuillez autoriser l'accès à la caméra pour utiliser cette fonctionnalité.");
          }
        }
      });
    } else {
      action[fn]().subscribe({
        error: () => { }
      });
    }
  }

  AjouterEtiquette(etiquette: number) {
    if (etiquette > 0 && !this.resultEtiquetteTypeSac.some(x => x.etiquette === etiquette)) {
      this.resultEtiquetteTypeSac.push({
        etiquette: etiquette,
        typeSac: new TypeSacCremation(),
        statuCommandeId: this.StatutCommandeSelect.id
      });
      this.audioPlayer.nativeElement.play();
      this.TxtAjoutEtiquetteManuelle = 0;
    }
  }

  AjouterEtiquetteManuellement() {
    this.AjouterEtiquette(this.TxtAjoutEtiquetteManuelle);
  }

  async ValiderScan() {
    this.messageErreurInformation = "";

    if (this.action?.isLoading) {
      this.messageErreurInformation = "Veuillez attendre que la caméra soit initialisée.";
      return;
    }

    if (this.resultEtiquetteTypeSac.length === 0) {
      this.messageErreurInformation = "Veuillez scanner une ou plusieurs étiquettes";
      return;
    }

    const hasMissingType = this.isChauffeur() &&
      this.resultEtiquetteTypeSac.some(x => x.typeSac.id === undefined);

    if (hasMissingType) {
      this.messageErreurInformation = "Veuillez sélectionner un type de sac pour chaque étiquette";
      return;
    }

    this.resultEtiquetteTypeSac.forEach(x => {
      x.statuCommandeId = this.StatutCommandeSelect.id;
    });

    const reponse = await this._StatutCommandeService.UpdateStatutCommande(this.resultEtiquetteTypeSac);

    if (reponse.statusCode === 200) {
      this.messageSuccesInformation = reponse.message;
      this.resultEtiquetteTypeSac = [];
      this.TxtLstEtiquettes = "";
      this._location.back();
    } else {
      this.messageErreurInformation = reponse.messageException;
    }
  }

  SupprimerLstEtiquettes(dataItem: any) {
    this.resultEtiquetteTypeSac = this.resultEtiquetteTypeSac.filter(x => x.etiquette !== dataItem.etiquette);
  }

  // Gère le retour arrière : empêche si la caméra est encore en chargement
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event) {
    if (this.action?.isLoading) {
      history.pushState(null, '', location.href); // Bloque sans alerter
    }
  }

  retourSiPret() {
    if (this.action?.isLoading) {

      return;
    }
    this._location.back();
  }
}
